import { useState, useEffect } from 'react';

function formatClock(d: Date): string {
  const pad = (n: number) => n.toString().padStart(2, '0');
  return `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}

/** Returns a live HH:MM:SS string that ticks every second. */
export function useClock(): string {
  const [time, setTime] = useState(() => formatClock(new Date()));

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(formatClock(new Date()));
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  return time;
}